module.exports = __webpack_public_path__ + "media/images/favicons/mstile-150x150-6cc788675776d621b06009df15b57d7d.png";